import React, { useContext, useRef, useState } from "react";
import "./Page.css";
import useTitle from "../Hooks/useTitle";
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { useTranslation } from "react-i18next";
import ToastContext from "../Context/toastContext";
import axiosClient from "../Utils/axiosClient";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);

  const forgotPasswordEmailRef = useRef();
  let dialogRef;


  const { t } = useTranslation();
  const { showToast } = useContext(ToastContext);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useTitle(`${t("Login")} | Netileti`);

  const loginClicked = async () => {
    try {
      const response = await fetch(`${baseUrl}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      if (response.ok) {
        const data = await response.json();

        localStorage.setItem("accessToken", data.accessToken);
        localStorage.setItem("refreshToken", data.refreshToken);
        localStorage.setItem("userEmail", email);
        const roleResponse = await fetch(
          `${baseUrl}/Users/GetUserRole/${email}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (roleResponse.ok) {
          const data = await roleResponse.text();
          localStorage.setItem("userRole", data);
        }

        window.location.href = "/";
      } else {
        console.error("Login failed");
        showToast(`${t("Login failed")}`, `${t("Error")}`);
      }
    } catch (error) {
      showToast(`${t("Error")} : ${error.message}`, `${t("Error")}`);
    }
  };

  const openForgotPassModal = () => {
    if (forgotPasswordEmailRef.current) {
      forgotPasswordEmailRef.current.value = email;
    }
    setModalOpen(true);
  };

  const closeForgotPassModal = () => {
    setModalOpen(false);
  };

  const resetPasswordClicked = async () => {
    try {
      console.log("reset password clicked");
      const enteredEmail = forgotPasswordEmailRef.current.value;
      const response = await axiosClient.post("/forgotPassword", {
        email: enteredEmail,
      });

      if (response.status === 200) {
        //navigate(`/reset-password/${enteredEmail}`);
        closeForgotPassModal();
        showToast(`${t("mailSended")}`, `${t("Success")}`);
      } else {
        console.error(`${t("Password reset failed")}`);
        showToast(`${t("Password reset failed")}`, `${t("Error")}`);
      }
    } catch (error) {
      showToast(`${t("Error")} : ${error.message}`, `${t("Error")}`);
      console.error(error);
    }
  };

  let buttons = [
    {
      buttonModel: {
        content: t("Reset Password"),
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: () => {
        resetPasswordClicked();
      },
    },
    {
      buttonModel: {
        content: t("Cancel"),
        cssClass: "e-flat",
      },
      click: () => {
        closeForgotPassModal();
      },
    },
  ];

  return (
    <div className="login-container">
      <div className="containers">
        <div className="left-container">
          <img className="logo-big" src="/images/big.png" alt="login-xl" />
          <img className="logo-small" src="/images/logo.png" alt="login-sm" />
        </div>
        <div className="right-container">
          <input
            className="e-input"
            type="text"
            placeholder="E-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            className="e-input"
            type="password"
            placeholder={t("Password")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div className="small-content">
            <small style={{ textAlign: "left" }}>
              <button
                type="button"
                className="forgot-password-button"
                style={{
                  background: "none",
                  border: "none",
                  color: "var(--color-sf-primary-bg-color)",
                  cursor: "pointer",
                  textDecoration: "none",
                  fontSize: "inherit",
                }}
                onClick={() => (window.location.href = "/contactus")}
              >
                {t("message.unsubscribe.ctaText")}
              </button>
            </small>
            <small style={{ textAlign: "right" }}>
              <button
                type="button"
                className="forgot-password-button"
                style={{
                  background: "none",
                  border: "none",
                  color: "var(--color-sf-primary-bg-color)",
                  cursor: "pointer",
                  textDecoration: "none",
                  fontSize: "inherit",
                }}
                onClick={openForgotPassModal}
              >
                {t("Forgot Password")}
              </button>
            </small>
          </div>

          <ButtonComponent cssClass="e-primary" onClick={loginClicked}>
            {t("Login")}
          </ButtonComponent>
        </div>
      </div>
      {/* Forgot Pass Modal */}
      <DialogComponent
        visible={isModalOpen}
        width="400px"
        isModal={true}
        animationSettings={{ effect: "Zoom" }}
        header={t("Forgot Password")}
        close={closeForgotPassModal}
        showCloseIcon={true}
        buttons={buttons}
        ref={dialogRef}
      >
        <div>
          <input
            className="e-input"
            type="text"
            placeholder={t("E-mail")}
            ref={forgotPasswordEmailRef}
          />
        </div>
      </DialogComponent>
    </div>
  );
};

export default LoginPage;
